import { render, staticRenderFns } from "./TwismLogo.vue?vue&type=template&id=5bbd7019&"
import script from "./TwismLogo.vue?vue&type=script&lang=ts&"
export * from "./TwismLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports